import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M140.7 141.1H57.6l-.1-2.4c0-1.1-.1-2.2-.1-3.3 0-33.8 18.7-85.7 41.7-85.7 23 0 41.7 51.8 41.7 85.7 0 1.1 0 2.2-.1 3.3v2.4zM99.5 48.9c-12.2 0-22.2-10.5-22.2-23.4 0-13 10-23.5 22.2-23.5s22.2 10.5 22.2 23.4c0 13-9.9 23.5-22.2 23.5zm98.1 92.2h-48.8l.1-2.6c0-1.2.1-2.4.1-3.6 0-17.7-11.5-58.3-18.6-69.4l-1.1-1.7 1.3-1.5c7.3-8.2 16.1-12.6 25.5-12.6 23 0 41.7 51.8 41.7 85.7 0 1.1 0 2.2-.1 3.3l-.1 2.4zm-41.1-92.2c-12.2 0-22.2-10.5-22.2-23.4 0-12.9 10-23.4 22.2-23.4s22.2 10.5 22.2 23.4c0 12.9-10 23.4-22.2 23.4zM51 141.1H2.2l-.1-2.4c0-1.1-.1-2.2-.1-3.3 0-33.8 18.7-85.7 41.7-85.7 9.3 0 18.1 4.3 25.5 12.6l1.3 1.5-1.1 1.7c-7.1 11.1-18.6 51.7-18.6 69.4 0 1.2 0 2.4.1 3.6l.1 2.6zm-7.7-92.2c-12.2 0-22.2-10.5-22.2-23.4 0-13 10-23.5 22.2-23.5s22.2 10.5 22.2 23.4c0 13-9.9 23.5-22.2 23.5zM2 176.6c0-11.8 9.6-21.4 21.4-21.4h153.1c11.8 0 21.4 9.6 21.4 21.4s-9.6 21.4-21.4 21.4H23.4C11.6 198 2 188.4 2 176.6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}